import React from 'react';

// PI / Group PI printed as a sales contract: the title becomes SALES CONTRACT and the
// validity lines are replaced by the shipment and expiry dates picked here.
// withTerms: also show the sales-contract-only term boxes (payment, other terms,
// importer bank, description of goods, net/gross weight) under the toolbar.
export const SalesContractToolbar = ({ salesContract, setSalesContract, withTerms = false }) => (
  <>
  <span style={{ marginLeft: '12px', display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: '13px' }}>
    <label style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
      <input
        type="checkbox"
        checked={salesContract.on}
        onChange={(e) => setSalesContract((prev) => ({ ...prev, on: e.target.checked }))}
      />
      Sales Contract
    </label>
    {salesContract.on && (
      <>
        <span>Shipment</span>
        <input type="date" value={salesContract.shipmentDate} onChange={(e) => setSalesContract((prev) => ({ ...prev, shipmentDate: e.target.value }))} />
        <span>Expiry</span>
        <input type="date" value={salesContract.expiryDate} onChange={(e) => setSalesContract((prev) => ({ ...prev, expiryDate: e.target.value }))} />
      </>
    )}
  </span>
  {salesContract.on && withTerms && <SalesContractTermsInputs salesContract={salesContract} setSalesContract={setSalesContract} />}
  </>
);

const termBox = { display: 'flex', flexDirection: 'column', gap: '2px', fontSize: '12px' };

const SalesContractTermsInputs = ({ salesContract, setSalesContract }) => {
  const set = (key) => (e) => { const value = e.target.value; setSalesContract((prev) => ({ ...prev, [key]: value })); };
  return (
    <span style={{ flexBasis: '100%', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '8px', marginTop: '6px', padding: '8px', border: '1px solid #ccc', borderRadius: '4px', background: '#fafafa' }}>
      <label style={termBox}>Payment
        <input value={salesContract.payment} onChange={set('payment')} placeholder="At Sight" />
      </label>
      <label style={termBox}>Others Terms
        <textarea rows={3} value={salesContract.otherTerms} onChange={set('otherTerms')} placeholder="Buyer's own terms (carton quality, delivery days...)" />
      </label>
      <label style={termBox}>Importer Bank
        <textarea rows={3} value={salesContract.importerBank} onChange={set('importerBank')} placeholder="Account name, bank, account no., routing, SWIFT, address" />
      </label>
      <label style={termBox}>Description of Goods
        <textarea rows={2} value={salesContract.goodsDescription} onChange={set('goodsDescription')} placeholder="e.g. Coverall 83520 pcs" />
      </label>
      <label style={termBox}>Net Weight (Kgs)
        <input value={salesContract.netWeight} onChange={set('netWeight')} placeholder="e.g. 2,971.38" />
      </label>
      <label style={termBox}>Gross Weight (Kgs)
        <input value={salesContract.grossWeight} onChange={set('grossWeight')} placeholder="e.g. 2,977.29" />
      </label>
    </span>
  );
};

export const emptySalesContract = {
  on: false,
  shipmentDate: '',
  expiryDate: '',
  payment: 'At Sight',
  otherTerms: '',
  importerBank: '',
  goodsDescription: '',
  netWeight: '',
  grossWeight: '',
};

// "2026-11-30" -> "30.11.2026"; blank leaves a line to write on.
export const scDate = (value) => (value ? value.split('-').reverse().join('.') : '____________');

// On a sales contract, PI numbers print with SC instead: "PI/ABC/123" -> "SC/ABC/123".
// In a Group PI number any PI / GPI / MPI part becomes SC ("XYZ/GPI/05" -> "XYZ/SC/05").
export const toScNo = (no) => (no ? String(no).replace(/(^|[\s/\-.])[GM]?PI(?=[\s/\-.]|$)/gi, '$1SC') : no);
